import { Button, Card, Skeleton } from "antd";
import React, { useContext, useEffect, useState } from "react";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import { useNavigate } from "react-router-dom";
import { downloadCSV, formatDate, getUserRole } from "../../services/util";
import HTTP from "../../services/httpService";
import { ReceiptFilterSelect } from "./SharedComponent";

const Receipt = () => {
    const {
        selectedDates,
        setSingleSelectedHotels,
        selectedHotels,
        kioskSelection,
        setSelectedCheckinType,
        selectedCheckinType,
    } = useContext(SettingContext);
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filterValue, setFilterValue] = useState(selectedCheckinType);
    const hotel_ids = selectedHotels;
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [start_date, end_date] = selectedDates;

    const [sortedInfo, updateSortedInfo] = useState({
        order: "descend",
        columnKey: "receipts_sent_via_print_counts",
    });
    const [formData, setFormData] = useState({
        staff_id,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        hotel_type: "all",
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        page: 0,
        limit: 10,
        transaction_via: filterValue,
        calling_hotel_type: Number(kioskSelection),
        sort_by: sortedInfo.columnKey,
        sorting: sortedInfo.order === "ascend" ? 2 : 1,
    });

    function getHotelWiseReceipts(e) {
        const hotel_id = e.currentTarget.getAttribute("id");
        const hotel_name = e.currentTarget.getAttribute("data-hotelname");
        setSingleSelectedHotels(`${hotel_name}#${hotel_id}`);
        return navigate(`/sent_receipt/${hotel_id}`);
    }

    const columns = [
        {
            title: "Hotel",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            render: (text, record) => (
                <span
                    onClick={getHotelWiseReceipts}
                    id={record.hotel_id}
                    data-hotelname={text}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                >
                    {text}
                </span>
            ),
            sortOrder:
                sortedInfo.columnKey === "hotel_name" ? sortedInfo.order : null,
        },
        {
            title: "Prints",
            dataIndex: "receipts_sent_via_print_counts",
            key: "receipts_sent_via_print_counts",
            sorter: true,
            sortOrder:
                sortedInfo.columnKey === "receipts_sent_via_print_counts"
                    ? sortedInfo.order
                    : null,
        },
        {
            title: "Mails",
            dataIndex: "receipts_sent_via_mail_counts",
            key: "receipts_sent_via_mail_counts",
            sorter: true,
            sortOrder:
                sortedInfo.columnKey === "receipts_sent_via_mail_counts"
                    ? sortedInfo.order
                    : null,
        },
    ];

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 2 : 1;
            others.sort_by = columnKey;
            updateSortedInfo({ columnKey, order });
        } else {
            delete formData.sorting;
            delete formData.sort_by;
            updateSortedInfo({});
        }

        const newFormData = {
            ...formData,
            ...others,
        };
        setFormData(newFormData);
        setCurrentPage(current);
    }

    const {
        status: receiptCountStatus,
        data: receiptCountRes,
        refetch: fetchReceiptCount,
    } = useQuery(
        "receiptTable",
        async () => {
            return await HTTP(
                "/dashboard/getDashboardReceiptsSentCountsHotelWise",
                { ...formData },
            );
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchReceiptCount();
    }, []);

    useEffect(() => {
        fetchReceiptCount();
    }, [formData]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            page: 0,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
            hotel_ids,
            all_selected: hotel_ids.length === 0 ? true : false,
            transaction_via: Number(filterValue),
            calling_hotel_type: Number(kioskSelection),
        });
    }, [selectedDates, selectedHotels, filterValue, kioskSelection]);

    useEffect(() => {
        if (receiptCountStatus === "success") {
            const { data: receiptData, total } = receiptCountRes;
            setTotalRecords(total);
            setTableData(receiptData);
        }
    }, [receiptCountStatus, receiptCountRes]);

    async function downalodReport() {
        const tempFormData = { ...formData };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        delete tempFormData["sorting"];
        delete tempFormData["sort_by"];
        const res = await HTTP(
            "/dashboard/getDashboardReceiptsSentCountsHotelWiseReport",
            {
                ...tempFormData,
            },
        );
        downloadCSV(res, `All_sent_receipt_report`);
    }

    const handleFilterChange = (e) => {
        setSelectedCheckinType(e);
        setFilterValue(e);
    };

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    <>
                        {(getUserRole() == "Super Admin" ||
                            getUserRole() == "Admin" ||
                            getUserRole() == "Management") && (
                            <Button
                                type="primary"
                                className="margin-right-5"
                                onClick={downalodReport}
                            >
                                Download
                            </Button>
                        )}
                    </>
                }
            />
            <ReceiptFilterSelect
                handleSelectChange={handleFilterChange}
                filterValue={filterValue}
            />
            {receiptCountStatus === "loading" ||
            receiptCountStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    currentPage={currentPage}
                    handleTableChange={handleTableChange}
                    rowKey="receipt-id"
                />
            )}
        </Card>
    );
};

export default Receipt;
